
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { DashboardComponent } from './inject-solar/dashboard/dashboard.component';


@Injectable()//service
export class StoreFirstGuard{
private firstNavigation=true;
loginToken=localStorage.loginToken
constructor(
    private router:Router
){}

canActivate(route:ActivatedRouteSnapshot,state:RouterStateSnapshot):boolean{

  if(this.firstNavigation){
      this.firstNavigation=false;
      // if(this.loginToken){
      //   this.router.navigateByUrl("/#/login");
      //   return false;
      // }
  }

  return true;
  }
  }
